import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminationFetchAction from './inseminationFetch.action.json' with { type: 'json' }
import { inseminationObject } from '../inseminationObject'
import { semenProgramObject } from '~/packages/rural/semenProgram/semenProgramObject'
import { inseminatorObject } from '~/packages/rural/inseminator/inseminatorObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { materialObject } from '../../material/materialObject'
import { semenBatchObject } from '../../semenBatch/semenBatchObject'
import { bullObject } from '../../bull/bullObject'

const inseminationFetchDefinition = defineAction({
  ...inseminationFetchAction,

  input: z.object({ id: inseminationObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: inseminationObject.extend({
    program: semenProgramObject.nullish(),
    inseminator: inseminatorObject
      .extend({
        citizen: citizenObject.nullish(),
      })
      .nullish(),
    citizen: citizenObject,
    residence: residenceObject.nullish(),
    batch: semenBatchObject.extend({
      bull: bullObject.nullish(),
    }),
    materials: z.array(materialObject).nullish(),
  }),
})

export default inseminationFetchDefinition
